import React from 'react'
import LinkMUI from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export default function CopyrightText({ standard = true }) {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <LinkMUI href="https://www.gopontio.com/" style={{ color: 'inherit !important' }}>
        Pontio
      </LinkMUI>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}
